import * as SelectPrimitive from "@radix-ui/react-select";
import { FaChevronDown } from "react-icons/fa";
import "../assets/css/product.css";

export function CustomSelect({
  options = [],
  placeholder = "Select...",
  onChange,
  value,
  icon,
  showLabel,
  labelName,
  customClass,
}) {
  const selectedOption = options.find((option) => option.value === value);

  return (
    <>
      {showLabel && labelName && (
        <label className="custom-select-label">{labelName}</label>
      )}
      <SelectPrimitive.Root onValueChange={onChange} value={value || ""}>
        <SelectPrimitive.Trigger
          className={`custom-select-trigger ${customClass ? customClass : ""}`}
        >
          <SelectPrimitive.Value placeholder={placeholder}>
            {selectedOption ? selectedOption.label : placeholder}
          </SelectPrimitive.Value>
          <SelectPrimitive.Icon>
            {icon ? icon : <FaChevronDown />}
          </SelectPrimitive.Icon>
        </SelectPrimitive.Trigger>

        <SelectPrimitive.Portal>
          <SelectPrimitive.Content
            className="custom-select-content"
            position="popper"
            sideOffset={5}
            align="center"
            avoidCollisions
          >
            <SelectPrimitive.Viewport
              className={`${customClass ? customClass : ""}`}
            >
              {options.map((option, index) => (
                <SelectPrimitive.Item
                  key={index}
                  value={option.value}
                  className="custom-select-item"
                >
                  <SelectPrimitive.ItemText>
                    {option.label}
                  </SelectPrimitive.ItemText>
                </SelectPrimitive.Item>
              ))}
            </SelectPrimitive.Viewport>
          </SelectPrimitive.Content>
        </SelectPrimitive.Portal>
      </SelectPrimitive.Root>
    </>
  );
}
